import Vue from 'vue';
import VueMarkdown from 'vue-markdown';

Vue.use(VueMarkdown);



// WEBPACK FOOTER //
// ./src/plugins/markdown.js